import { render, staticRenderFns } from "./AppBarNotification.vue?vue&type=template&id=3e9e2f88&scoped=true"
import script from "./AppBarNotification.vue?vue&type=script&lang=js"
export * from "./AppBarNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9e2f88",
  null
  
)

export default component.exports